import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #916ee8;
  height: 24px;
  width: 24px;
`

export const ShieldLessIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={className}>
      <path d="M9.9 15.1158L12 13.0158L14.1 15.1158L15.1538 14.0621L13.0538 11.9621L15.1538 9.86206L14.1 8.80831L12 10.9083L9.9 8.80831L8.84625 9.86206L10.9463 11.9621L8.84625 14.0621L9.9 15.1158ZM12 21.4813C9.83717 20.8915 8.0465 19.6184 6.628 17.6621C5.20933 15.7057 4.5 13.5186 4.5 11.1006V5.34681L12 2.53906L19.5 5.34681V11.1006C19.5 13.5186 18.7907 15.7057 17.372 17.6621C15.9535 19.6184 14.1628 20.8915 12 21.4813ZM12 19.9006C13.7333 19.3506 15.1667 18.2506 16.3 16.6006C17.4333 14.9506 18 13.1172 18 11.1006V6.37556L12 4.13506L6 6.37556V11.1006C6 13.1172 6.56667 14.9506 7.7 16.6006C8.83333 18.2506 10.2667 19.3506 12 19.9006Z" />
    </Svg>
  )
}
